import React from 'react';
import { COProductCardPropsEnums } from 'enums/COProductCardEnums';
import { Product } from 'models/Product/product.model';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import { ReactComponent as VerifiedIcon } from 'assets/icons/verified.svg';
import { ReactComponent as EditIcon } from 'assets/icons/draft.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ChildProduct } from 'models/ChildProduct/childProduct.model';
import { Commodity } from 'models/CommodityList/Commodity.model';
export interface COProductCardProps {
  data: ChildProduct | Commodity;
  multiRowCard?: boolean;
  commodityCard?: boolean;
  commodityDetailsCard?: boolean;
  showStatus?: boolean;
  showDownloadOptions?: string;
  calenderRow?: boolean;
  iconRender?: boolean;
  declineOption?: boolean;
  onDeleteClick?: (value: number, type?: string) => void;
  onCopyClick?: (value: number) => void;
  navigateProductOverview: (
    productId?: number,
    stage?: number,
    stauts?: string,
    type?: string
  ) => void;
  onDeclineReasonClick?: (productData?: Product) => void;
  isProduct?: boolean;
}
export type MenuItem = {
  key: string;
  domEvent?: { stopPropagation: () => void };
};
type StylesType = {
  [key: string]: string;
};
export const getStatusClassName = (styles: StylesType, status?: string) => {
  switch (status) {
    case 'declined':
      return styles.declineValue;
    case 'approved':
      return styles.approvedValue;
    case 'in review':
      return styles.reviewValue;
    case 'draft':
      return styles.draftValue;
    default:
      return styles.draftValue;
  }
};
const { DRAFT, APPROVED, DECLINED } = COProductCardPropsEnums;
export const renderIcon = (styles: StylesType, status?: string) => {
  switch (status) {
    case DRAFT:
      return (
        <div className={styles.editIconContainer}>
          <EditIcon className={styles.productIcon} />
        </div>
      );
    case APPROVED:
      return (
        <div className={styles.verifiedIconContainer}>
          <VerifiedIcon className={styles.productIcon} />
        </div>
      );
    case DECLINED:
      return (
        <div className={styles.closeIconContainer}>
          <CloseIcon className={styles.productIcon} />
        </div>
      );
    default:
      return (
        <div className={styles.searchIconContainer}>
          <SearchIcon className={styles.productIcon} />
        </div>
      );
  }
};
export const pageCountOne = 1;
